<template>
  <div
    class="shop_item"
  >
    <div class="left" ref="shopLeft">
      <div class="shopTitle">
        <div v-if="item.isFavorite" class="collect-icon"></div>
        <div class="shopType" :style="{ backgroundColor: item.shopTitleColor }">
          <span class="shopTypeName">
            {{ item.shopTypeName }}
          </span>
        </div>
        <div class="shop_name"> {{ item.shopName }} </div>
      </div>

      <div v-if="isWillOpen" class="will-open-time-div">
        <span v-if="item.businessTime" class="will-open-time">
          {{ item.currentSaleTime }}
        </span>
      </div>

      <div v-else>
        <div v-if="isShowClosed" class="work-time-div">
          <span class="shop_time" :style="{ 'padding-left': '0', 'font-size': '22px' }">
            {{ item.currentSaleTime || '今日门店休息' }}
          </span>
        </div>

        <div
          v-else
          class="work-time-div2"
          :style="{
            border: item.closed == 2 ? '1px solid #DFDFDF' : '1px solid #ffffff'
          }"
        >
          <span class="shop_time" :style="{ 'padding-left': item.closed == 2 ? '4px' : '0' }">
            {{ item.currentSaleTime || '今日门店休息' }}
          </span>
          <span class="shop_state" v-if="item.closed == 2">
            休息中
          </span>
        </div>
      </div>

      <div class="shop_address ellipsis-2 font-d4">
        <span v-if="item.distance || item.distance == 0" class="distance">
          距您 <label class="distance-icon">{{ item.distance }}m</label>
        </span>  
        <span class="separator">|</span>
        <span>{{ item.address }}</span>
      </div>

      <!-- 自定义营销标签 -->
      <div class="marketing-card" v-if="item.marketLabelList && item.marketLabelList.length">
        <div
          :class="{'marketing-scroll':true,'marketing-list': tagHidden}"
          ref="marketingList"
        >
            <div
              class="marketing-item" v-for="(item,index) in item.marketLabelList" :key="index" 
              :style="[calcMarketingStyle(item)]"
            >
              {{ item.name }}
            </div>
        </div>
        <img v-if="isTagHidden" class="icon" src="https://cdn-product-prod.yummy.tech/wechat/cotti/images/home/arrow_right_0110.svg" />

      </div>
    </div>
    <div class="center"></div>
    <div class="right">
      <div class="first_child" @click="toShop(item.shopMdCode)">
        <span class="span_xiadan font-d6">{{ item.closed == 2 ? '去看看' : '去下单' }}</span>
      </div>
      <img v-if="item.empMobile" class="icon" src="https://cdn-product-prod.yummy.tech/wechat/cotti/images/7487-image/icon_shop_phone_250821.svg" @click="toPhone(item.empMobile)" />
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import {isCottiApp} from "@/utils";
// import { judgeInsideServiceTime } from '@/utils/common/service-time'
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    linkTerminal: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tagHidden: false,
      isTagHidden: false
    }
  },
  computed: {
    // ...mapOrderFactorsState(['storeInfo']),
    // ...mapState({
    //   getConfig: state => state.app.appConfig
    // }),
    shopTypeName() {
      let shopType = '快取店'
      this.markTypeDes.forEach(element => {
        if (this.item.shopType == element.index) {
          shopType = element.name
        }
      })
      return shopType
    },

    isShowClosed() {
      return this.item.closed && this.item.showSaleType == 2
    },
    isWillOpen() {
      return this.item.status == 0
    }
  },
  mounted() {
    this.checkMarketingTag()
  },
  methods: {
    goNavigation(item) {
      this.$track('store_list_item_navi_click', {
        store_closed: item.closed ? '是' : '否'
      })
      console.log('唤起导航地图')
      uni.openLocation({
        latitude: Number(item.latitude),
        longitude: Number(item.longitude),
        name: item.shopName,
        address: item.address,
        success: () => {
          console.log('success')
        }
      })
    },
     toShop (shopMdCode) {
      if (Number(this.linkTerminal) === 1) {
          wx.miniProgram.switchTab({
              url: `/pages/purchase/index?shop=${shopMdCode}`,
            });
        } else if (Number(this.linkTerminal) === 3) {
          if (this.$config.env.VUE_APP_BRAND == "COTTI") {
             const data = `{"path":"cottitab://coffee?tabIndex=1&shopMdCode=${shopMdCode}"}`;
             CottiNavigation.postMessage(data);
          } else {
            const data = `{"path":"teacattab://coffee?tabIndex=1&shopMdCode=${shopMdCode}"}`;
            CottiNavigation.postMessage(data);
          }
        } else if (Number(this.linkTerminal) === 4) {
          my.switchTab({
            url: `/pages/purchase/index?shop=${shopMdCode}`,
            success: function (res) {
              console.log(res, '成功');
            },
            fail: function (err) {
              console.log(err);
            }
          });
        }
    },
    distance(num) {
      if (num > 1000) {
        return (num / 1000).toFixed(2) + 'km'
      }
      return num + 'm'
    },
    // 自定义营销标签样式
    calcMarketingStyle(item){
      const style = {
        'color': item.fontColor || '#666666',
        'padding': (item.backgroundColor || item.frameColor) ? '0 6px' : '',
        'border': item.frameColor ? `1px solid ${item.frameColor}` : 'none',
        'background': item.backgroundColor ? item.backgroundColor : '',
      }
      return style
    },
    // 判断是否多行标签
    checkMarketingTag() {
      this.$nextTick(()=>{
        const marketingDom = this.$refs.marketingList
        const shopLeftDom = this.$refs.shopLeft
        console.log(marketingDom.scrollWidth,'---');
        console.dir(marketingDom,'---');
        console.dir(shopLeftDom,'-shopLeftDom--');
        console.dir(shopLeftDom.clientWidth,'-clientWidth--');
        
        if (Number(marketingDom.scrollWidth) > shopLeftDom.clientWidth) {
          this.isTagHidden = true
          this.tagHidden = true
          // this.scrollToPosition(20)

          // setTimeout(() => {
          //   this.scrollToPosition(0)
          // }, 1000);
        }
      })
    },
    scrollToPosition(position) {
      const marketingDom = this.$refs.marketingList;
      const start = marketingDom.scrollLeft;
      const change = position - start;
      const duration = 500; // 动画持续时间，单位为毫秒
      let currentTime = 0;
      const increment = 20;

      const animateScroll = () => {
        currentTime += increment;
        const val = this.easeInOutQuad(currentTime, start, change, duration);
        marketingDom.scrollLeft = val;
        if (currentTime < duration) {
          requestAnimationFrame(animateScroll);
        }
      };

      animateScroll();
    },
    easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    },
    toPhone(empMobile) {
      if (empMobile) {
        if(isCottiApp()) {
          const data = `{"path":"callphone://coffee?phoneNumber=${empMobile}"}`;
          CottiNavigation.postMessage(data);
        } else {
          window.location.href = 'tel://' + empMobile
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.shop_item {
  position: relative;
  width: calc(100% - 24px);
  padding: 28px 0 28px 24px;
  background: #ffffff;
  display: flex;
  border-radius: 16px;
  border: 1px solid #EEEEEE;
  overflow: hidden;
  transform: translate3d(0, 0, 0);
  margin-top: 24px;
  justify-content: space-between;
  .oftenUsedShopListLogo {
    position: absolute;
    width: 40px;
    height: 40px;
    top: -2px;
    left: -2px;
  }
  .left {
    width: 446px;
    padding-right: 32px;
    .collect-icon {
      width: 24px;
      height: 24px;
      background: url(../../../assets/collect-icon.png) no-repeat;
      background-size: contain;
      margin-right: 16px;
    }
    .shopTitle {
      display: flex;
      align-items: center;
      padding-right: 24px;
      .shopType {
        height: 32px;
        line-height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        vertical-align: middle;
        margin-top: -2px;
        border-radius: 4px;
        .shopTypeName {
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          padding: 0 6px;
          white-space: nowrap;
          border-radius: 3px;
        }
      }

      .shop_name {
        margin-left: 8px;
        font-size: 26px;
        font-weight: 500;
        color: #3A3B3C;
        line-height: 40px;
        height: 40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
      }
    }

    .will-open-time-div {
      width: fit-content;
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 32px;
      line-height: 32px;
      border-radius: 4px;
      border: 1px solid var(--text-color);
      margin: 22px 0 16px;
      .will-open-time {
        font-size: 24px;
        color: #5e5e5e;
        padding: 0 8px;
        text-align: center;
        height: 24px;
        line-height: 24px;
      }
    }

    .work-time-div, .work-time-div2 {
      width: fit-content;
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 31px;
      border-radius: 4px;
      margin: 16px 0 16px;
      vertical-align: middle;
      overflow: hidden;
    }
    .work-time-div2 {
      background: #F9F8F8;
      border-radius: 6px;
      .shop_time {
        color: #AEAEAE!important;
        border-right: 1px solid #DFDFDF;
      }
    }
    .shop_state {
      font-size: 22px;
      color: #ffffff;
      line-height: 34px;
      padding: 0 8px;
      background: var(--text-color);
      vertical-align: middle;
      height: 32px;
      background: #F9F8F8;
      color: #5E5E5E;
    }
    .shop_time {
      font-size: 22px;
      color: #5e5e5e;
      line-height: 26px;
      background: #ffffff;
      padding: 4px 8px;
      height: 24px;
      border-radius: 4px;
    }
    .shop_address {
      font-size: 24px;
      font-weight: 400;
      line-height: 36px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
      max-width: 390px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      font-size: 22px;
      font-weight: 400;
      color: #3A3B3C;
    }
    .distance-icon {
      font-weight: 600;
      margin-right: 5px;
    }
    .separator {
      margin: 0 7px 0 2px;
    }

    .card_line {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-top: 14px;
      &-icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      &-title {
        font-size: 22px;
        line-height: 32px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }
  .center {
    width: 1px;
    background: #EEEEEE;
  }
  .right {
    width: 136px;
    flex: 0 none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .first_child {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .span_xiadan {
      font-size: 24px;
      font-weight: 500;
      line-height: 44px;
      color: var(--title-color);
      font-family: PingFangSC, PingFang SC;
    }
    > .icon {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      // margin: auto 0;
      > div {
        display: flex;
        justify-content: center;
        align-items: center;
        > div {
          width: 28px;
          height: 28px;
          margin-right: 8px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        > span {
          font-size: 24px;

          color: #4aa1ff;
        }
      }
    }
  }
}
.empty-div {
  height: 32px;
}
.mask {
  background: white;
  opacity: 0.4;
  position: absolute;
}
.marketing-card{
  margin-top: 20px;
  display: flex;
  align-items: flex-end;
  // height: 16px;
  .marketing-list{
    overflow-x: auto;
    // max-width: 450px;
  }
  /* 针对WebKit浏览器隐藏滚动条 */
  .marketing-list::-webkit-scrollbar {
    display: none; /* 隐藏滚动条 */
  }
  
  .marketing-list {
    -ms-overflow-style: none; /* IE和Edge */
    scrollbar-width: none; /* Firefox */
  }
  .marketing-scroll{
    white-space: nowrap;
    width: auto;
  }

  .marketing-item{
    height: 32px;
    font-size: 18px;
    margin-right: 12px;
    line-height: 32px;
    border-radius: 18px 18px 18px 4px;
    display: inline-block;
    box-sizing: border-box;
  }
  .icon{
      width: 32px;
      height: 32px;
    }
}
</style>
